import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import React from 'react';
import { useContextClient } from './index';
export function useContextData() {
    const contextClient = useContextClient();
    const [channels, setChannels] = React.useState([]);
    const [owners, setOwners] = React.useState([]);
    const [userData, setUserData] = React.useState();
    React.useEffect(() => {
        Promise.all([contextClient.getChannels(), contextClient.getOwners(), contextClient.getUser()])
            .then((valArray) => {
            setChannels(valArray[0]);
            const writeOwners = valArray[1].filter((owner) => {
                return owner.right.includes('edit') || owner.right.includes('write');
            });
            setOwners(writeOwners);
            setUserData(valArray[2]);
        })
            .catch(handleErrorSnackbar);
    }, [contextClient]);
    if (!channels || !owners || !userData) {
        return undefined;
    }
    return {
        channels: channels,
        owners: owners,
        userData: userData,
    };
}
